import { render, staticRenderFns } from "./createuser.vue?vue&type=template&id=24c79f6f"
import script from "./createuser.vue?vue&type=script&lang=js"
export * from "./createuser.vue?vue&type=script&lang=js"
import style0 from "./createuser.vue?vue&type=style&index=0&id=24c79f6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports